export default "__VITE_ASSET__344cc184__"